import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { OpenOrdersClient, OPEN_STATES, type OpenOrdersSearch } from "@/features/openOrders/OpenOrdersClient";
import { listOpenOrders } from "@/features/openOrders/openOrders.api";
import { applyParamUpdates } from "@/lib/searchParams";

// Open to every internal role that reads proformas; the API enforces it.
export const Route = createFileRoute("/_shell/open-orders")({
  validateSearch: (search: Record<string, unknown>): OpenOrdersSearch => ({
    q: typeof search.q === "string" && search.q ? search.q : undefined,
    lead: search.lead === "mine" ? "mine" : undefined,
    state:
      typeof search.state === "string" && (OPEN_STATES as readonly string[]).includes(search.state)
        ? search.state
        : undefined,
  }),
  component: OpenOrdersPage,
});

function OpenOrdersPage() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  // The whole list in one go (a few hundred orders); filtering is local. Refetched
  // on the DataBridge's own rhythm, so a screen left open stays current.
  const query = useQuery({ queryKey: ["open-orders"], queryFn: listOpenOrders, refetchInterval: 5 * 60_000 });

  function updateParams(updates: Record<string, string>) {
    void navigate({
      to: "/open-orders",
      search: (prev) => applyParamUpdates(prev as Record<string, string | undefined>, updates),
      replace: true,
    });
  }

  return <OpenOrdersClient result={query.data} isLoading={query.isLoading} search={search} updateParams={updateParams} />;
}
